import { styled, Paper as MiUiPaper } from "@mui/material";

const CardPaper = styled(MiUiPaper)(({ theme }) => ({
  borderRadius: theme.spacing(1.875),
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.06)",
}));

export { CardPaper };
